function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { TextInput } from '@cbhq/cds-web/controls/TextInput';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { useGlobalMicrocopy } from '../../providers/MicrocopyProvider.js';
import { getIsValidEmail } from '../../utils/getIsValidEmail.js';
import { Button } from '../Button.js';
import '../Div/index.js';
import { Text } from '../Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function EmailOnlyUserForm({
  successMessage,
  placeholder,
  submitButtonLabel,
  onSuccess,
  onSubmit,
  style,
  formType
}) {
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showForm = _useState2[0],
    setShowForm = _useState2[1];
  const microcopies = useGlobalMicrocopy();
  if (formType === 'Signup') {
    // TODO: Switch on formType
  }
  if (showForm) {
    // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
    const onSuccessHandle = email => {
      setShowForm(false);
      onSuccess?.(email);
    };
    return /*#__PURE__*/jsx(Form, {
      placeholder: placeholder || microcopies.global.emailPlaceholder,
      submitButtonLabel: submitButtonLabel || microcopies.global.submit,
      onSuccess: onSuccessHandle,
      onSubmit: onSubmit,
      style: style
    });
  }
  return /*#__PURE__*/jsxs(Div, {
    css: {
      display: 'flex',
      alignItems: 'center'
    },
    justifyContent: {
      sm: 'center',
      md: 'flex-start'
    },
    children: [/*#__PURE__*/jsx(Icon, {
      name: "circleCheckmark",
      color: "positive",
      size: "s",
      spacingEnd: 2
    }), /*#__PURE__*/jsx(Text, {
      variant: "headline",
      as: "p",
      color: "positive",
      children: successMessage || microcopies.global.subscribed
    })]
  });
}
const CTAEmailFormValues = {
  email: 'email'
};
const CDSThemeProviderWithChildren = ThemeProvider;
function Form({
  placeholder,
  submitButtonLabel,
  onSuccess,
  onSubmit: onSubmitProp,
  style
}) {
  const _useForm = useForm(),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    getFieldState = _useForm.getFieldState,
    formState = _useForm.formState;
  const emailError = getFieldState('email', formState).error;
  const onSubmit = async ({
    email
  }) => {
    const success = await onSubmitProp(email);
    if (success) {
      onSuccess?.(email);
    }
  };
  const isDarkMode = style === 'dark' || style === 'darkwash';
  const background = componentsThemeMap[style].background;
  return /*#__PURE__*/jsx(Div, {
    flexDirection: {
      sm: 'column',
      md: 'row'
    },
    width: {
      sm: '100%',
      md: 'auto'
    },
    spacingTop: 3,
    children: /*#__PURE__*/jsxs(Div, {
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: {
        sm: '1fr',
        md: '1fr auto'
      },
      width: "100%",
      maxWidth: 550,
      gap: 3,
      children: [/*#__PURE__*/jsx(CDSThemeProviderWithChildren, {
        spectrum: isDarkMode ? 'dark' : 'light',
        children: /*#__PURE__*/jsx(TextInput, _objectSpread(_objectSpread({
          label: "",
          placeholder: placeholder
        }, register('email', {
          required: true,
          validate: getIsValidEmail
        })), {}, {
          type: "email",
          variant: emailError && 'negative'
        }))
      }), /*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: ANALYTICS_KEY.Submit,
        children: /*#__PURE__*/jsx(Button, {
          onPress: handleSubmit(onSubmit),
          variant: background === 'primary' ? 'secondary' : 'primary',
          children: submitButtonLabel || ''
        })
      })]
    })
  });
}
export { EmailOnlyUserForm };
//# sourceMappingURL=EmailOnlyUserForm.js.map
